import React from 'react';
import { useTranslation } from '@wix/wix-i18n-config';
import {
  SectionWixFooter,
  TranslatedContent,
  ISectionProps,
  ITextSection,
} from '@wix/shoutout-email-react';
import { WixComponentTypes, WixFooterType } from '@wix/shoutout-email-model-v3';

interface PropTypes extends ISectionProps {
  isRtl: boolean;
  section: ITextSection & { footerType: WixFooterType };
  content: TranslatedContent;
  backgroundColor: string;
  columnCssClass: string;
  cssClass: string;
  experiments: Record<string, string>;
}

export const SectionWixFooterWithContent = (props: PropTypes) => {
  const { t } = useTranslation();
  const content = {
    dontReply: t('wix.footer.content.dont.reply'),
    helpCenter: t('wix.footer.content.help.center'),
    helpCenterUrl: t('wix.footer.content.help.center.url'),
    privacyPolicy: t('wix.footer.content.privacy.policy'),
    privacyPolicyUrl: t('wix.footer.content.privacy.policy.url'),
    termsOfUse: t('wix.footer.content.terms.of.use'),
    termsOfUseUrl: t('wix.footer.content.terms.of.use.url'),
    companyAddressLine: t('wix.footer.content.company.address'),
  };

  const paymentsContent = {
    ...content,
    termsOfUse: t('wix.footer.content.payments.terms.of.use'),
    termsOfUseUrl: t('wix.footer.content.payments.terms.of.use.url'),
  };

  const riseContent = {
    ...content,
    helpCenterUrl: t('wix.footer.content.rise.help.center.url'),
    privacyPolicyUrl: t('wix.footer.content.rise.privacy.policy.url'),
    termsOfUse: t('wix.footer.content.rise.terms.of.use'),
    termsOfUseUrl: t('wix.footer.content.rise.terms.of.use.url'),
    companyAddressLine: t('wix.footer.content.rise.company.address'),
  };

  const footerMap: Record<WixFooterType, TranslatedContent> = {
    [WixComponentTypes.classic]: content,
    [WixComponentTypes.studio]: content,
    [WixComponentTypes.payments]: paymentsContent,
    [WixComponentTypes.rise]: riseContent,
  };

  return (
    <SectionWixFooter
      {...props}
      content={footerMap[props.section.footerType]}
    />
  );
};
